import { Activity, RankedActivity } from '../activities'
import { Facility, RankedFacility } from '../facilities'
import { UserId } from '../users'
import { Grade } from '../grades'
import { Gender } from '../../types'

export type ActivityRanking = RankedActivity & {
  topFacility: Facility
}

export type ListActivityRankingsResponse = ActivityRanking[]

export interface GetActivityFacilityRankingResponse {
  activity: Activity
  facilities: RankedFacility[]
  aggregatedAt: string
}

export enum RankingPrevMonthComparison {
  RANK_UP = 'rank_up',
  RANK_KEEP = 'rank_keep',
  RANK_DOWN = 'rank_down',
}

export interface RankedUser {
  userId: UserId
  targetMonth: string
  useAmount: number
  rank: number
  monthOverMonth: RankingPrevMonthComparison
  grade: Grade
  nickname: string
  imagePath: string | null
  enthusiasmComment: string | null
  age: string
  sex: Gender
  me: boolean
}

export interface GetUserRankingResponse {
  rankedUsers: RankedUser[]
  targetMonth: string
  createdAt: string
  myRank: number | null
}
